import { useLayoutEffect, useState } from 'react';

/** Where a Build side panel sits: just under the Build bar, whichever view drew it. */
export const useTopUnderBuildBar = () => {
  const [top, setTop] = useState(0);
  useLayoutEffect(() => {
    const measure = () => {
      const bar = document.querySelector('[data-testid="bobcat-build-topbar"]');
      setTop(bar ? bar.getBoundingClientRect().bottom : 0);
    };
    measure();
    window.addEventListener('resize', measure);
    const resize = new ResizeObserver(measure);
    const bar = document.querySelector('[data-testid="bobcat-build-topbar"]');
    if (bar) resize.observe(bar);
    return () => {
      window.removeEventListener('resize', measure);
      resize.disconnect();
    };
  }, []);
  return top;
};
